import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'

import DashboardSkeleton from './-components/dashboard-skeleton'

// Cartes de la vue d'ensemble qui ouvrent un panneau de détail. `detail` vit dans l'URL : le lien
// est partageable et le bouton « retour » du navigateur (ou du téléphone) referme le panneau.
export const DETAIL_KEYS = [
  'outdoorTemperature',
  'outdoorHumidity',
  'boilers',
  'circuits',
  'hotWater',
  'cta',
  'zoneComfort',
  'electrical',
  'medicalFluids',
  'lighting',
  'derogations',
  'logbook',
  'alertsPerMonth',
] as const

export type DetailKey = (typeof DETAIL_KEYS)[number]

export const SearchSchema = z.object({
  detail: z.enum(DETAIL_KEYS).optional(),
})

export type Search = z.infer<typeof SearchSchema>

export const Route = createFileRoute('/_dashboard/site/$id/dashboard/general/')({
  validateSearch: SearchSchema,
  pendingComponent: DashboardSkeleton,
})
